import "../assets/index-7fac55ed.css";
import { A as n } from "../chunks/actionText-60ff01d1.mjs";
import { n as o } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const a = {
  name: "NcActionRouter",
  mixins: [n],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: !1
    }
  },
  props: {
    /**
     * router-link to prop [https://router.vuejs.org/api/#to](https://router.vuejs.org/api/#to)
     */
    to: {
      type: [String, Object],
      default: "",
      required: !0
    },
    /**
     * router-link exact prop [https://router.vuejs.org/api/#exact](https://router.vuejs.org/api/#exact)
     */
    exact: {
      type: Boolean,
      default: !1
    }
  }
};
var r = function() {
  var t = this, e = t._self._c;
  return e("li", { staticClass: "action", attrs: { role: t.isInSemanticMenu && "presentation" } }, [e("RouterLink", { staticClass: "action-router focusable", attrs: { to: t.to, "aria-label": t.ariaLabel, exact: t.exact, title: t.title, rel: "nofollow noreferrer noopener", role: t.isInSemanticMenu && "menuitem" }, nativeOn: { click: function(l) {
    return t.onClick.apply(null, arguments);
  } } }, [t._t("icon", function() {
    return [e("span", { staticClass: "action-router__icon", class: [t.isIconUrl ? "action-router__icon--url" : t.icon], style: { backgroundImage: t.isIconUrl ? `url(${t.icon})` : null }, attrs: { "aria-hidden": "true" } })];
  }), t.name ? e("span", { staticClass: "action-router__longtext-wrapper" }, [e("strong", { staticClass: "action-router__name" }, [t._v(" " + t._s(t.name) + " ")]), e("br"), e("span", { staticClass: "action-router__longtext", domProps: { textContent: t._s(t.text) } })]) : t.isLongText ? e("span", { staticClass: "action-router__longtext", domProps: { textContent: t._s(t.text) } }) : e("span", { staticClass: "action-router__text" }, [t._v(t._s(t.text))]), t._e()], 2)], 1);
}, s = [], i = /* @__PURE__ */ o(
  a,
  r,
  s,
  !1,
  null,
  "fdbe574e",
  null,
  null
);
const p = i.exports;
export {
  p as default
};
